import React, { Component } from 'react';
import { hide } from 'src/utils/cookieBanner';
import api from 'src/utils/api';
const countriesWithCookieLaw = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GB', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
import i18n from 'i18next';
import { isUserBot } from 'src/utils/seo';

class CookieInfoBanner extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showCookieBanner: false,
    };
    this.timeout = null;
  }

  async componentDidMount() {
    if (!isUserBot) {
      const { data: { payload: { countryCode } } } = await api.auroraGet('iplookup');
      if (countriesWithCookieLaw.indexOf(countryCode) !== -1) {
        this.setState({ showCookieBanner: true });
      } else {
        this.dismissCookie();
      }

      this.timeout = setTimeout(() => {
        this.dismissCookie();
      }, 15000);
    }
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  dismissCookie = () => {
    this.setState({ showCookieBanner: false });
    hide();
  }

  render() {
    if (!this.state.showCookieBanner) {
      return null;
    }
    const cookieHref = `https://${window.location.host}/policies/cookies`;
    return <div className="cookie-info-bar">
      <span className="cookie-info-bar__accept icon-close" onClick={this.dismissCookie}/>
      <div className="cookie-info-bar__container">
        <div className="cookie-info-bar__text">
          {i18n.t('We use cookies to improve your experience. By continuing you agree to our ')}
          <a
            className="cookie-info-bar__policy"
            href={cookieHref}
            rel="nofollow"
            target="_blank"
            onClick={this.dismissCookie}
          >
            <span>{i18n.t('cookie policy')}</span>
          </a>
        </div>
      </div>
    </div>;
  }
}

export default CookieInfoBanner;



// WEBPACK FOOTER //
// ./src/components/cookieInfoBanner.js